import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TimesheetPage } from "@/features/timesheet/TimesheetPage";

const search = z.object({
  week: z.string().optional(),
});

export const Route = createFileRoute("/_app/time/")({
  validateSearch: search,
  component: () => <TimesheetPage search={Route.useSearch()} />,
});
